var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1727 3.16192C22.1898 2.53792 22.9702 1.54846 23.3365 0.369782C22.3842 0.949011 21.3319 1.3679 20.2092 1.59468C19.3133 0.612451 18.0328 0 16.6156 0C13.8968 0 11.6936 2.26058 11.6936 5.04839C11.6936 5.44417 11.7345 5.82984 11.819 6.19818C7.72812 5.98729 4.10072 3.97949 1.67072 0.92301C1.2467 1.67124 1.0044 2.53792 1.0044 3.46237C1.0044 5.21306 1.87357 6.75863 3.19493 7.66575C2.38774 7.63975 1.62846 7.41008 0.96355 7.03452V7.09663C0.96355 9.54355 2.65962 11.5846 4.91495 12.0468C4.50079 12.1652 4.06691 12.2245 3.61613 12.2245C3.29917 12.2245 2.98926 12.1941 2.69061 12.1349C3.31608 14.1398 5.13471 15.6016 7.29002 15.6406C5.6038 16.9955 3.48089 17.8015 1.17485 17.8015C0.777602 17.8015 0.384575 17.7799 0 17.7322C2.17926 19.1637 4.76704 20 7.54781 20C16.6057 20 21.5559 12.3068 21.5559 5.63484C21.5559 5.41528 21.5531 5.19717 21.5432 4.98194C22.5054 4.26983 23.3421 3.38004 24 2.36747C23.1167 2.76903 22.1673 3.04059 21.1727 3.16192Z",
    fill: "#13294B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e7d7e9f0a253b7853d7fb052f871a376.svg";
export { ForwardRef as ReactComponent };